
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 8.667v-6c0-.19.064-.348.192-.475A.645.645 0 018.667 2h4.666c.19 0 .348.064.475.192a.645.645 0 01.192.475V6a.645.645 0 01-.192.475.645.645 0 01-.475.192H10l-2 2zM13.3 14c-1.389 0-2.761-.303-4.117-.908-1.355-.606-2.589-1.464-3.7-2.575-1.11-1.111-1.97-2.345-2.575-3.7C2.303 5.46 2 4.089 2 2.7c0-.2.067-.367.2-.5s.3-.2.5-.2h2.7a.62.62 0 01.417.158.61.61 0 01.216.375l.434 2.334c.022.177.016.327-.017.45a.701.701 0 01-.183.316L4.65 7.267c.222.41.486.808.792 1.191.305.384.641.753 1.008 1.109.344.344.706.664 1.083.958.378.294.778.564 1.2.808L10.3 9.767c.1-.1.23-.175.392-.225.16-.05.32-.064.475-.042l2.3.467a.772.772 0 01.383.241c.1.117.15.248.15.392v2.7c0 .2-.067.367-.2.5s-.3.2-.5.2z"}})])
          )
        }
      }
    